import { z } from 'zod';
/*
  userIdSchema validates a userId parameter (Descope user ID).
  Descope user IDs are UUIDs or other unique identifiers.
  They must be non-empty strings.
*/
export const userIdSchema = z
    .string()
    .min(1, 'User ID cannot be empty')
    .max(255, 'User ID is too long');
/*
  userType distinguishes a real Kirin account from the lightweight KIR-3908
  kinds. `discovered` = auto-created from a scan email with no Kirin account;
  `unattributed` = the per-org placeholder for a missing/invalid scan email.
  Absent → treat as `full` (backward compatible for producers not yet updated).
*/
export const userTypeSchema = z.enum(['full', 'discovered', 'unattributed']);
/*
  userSchema defines the base structure for a user.
  This is a shared contract used across different contexts (organization members, scan history, etc.)
*/
export const userSchema = z.object({
    id: z.string(),
    internalId: z.string().uuid().nullable().optional(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    userType: userTypeSchema.optional(),
});
//# sourceMappingURL=user.js.map